import { useEffect, useState } from "react";
import Cookies from "js-cookie";

/**
 * A custom hook which tracks the user's navigation history
 * @param {*} reference - shipment ID or quick request ID
 * @param {*} type - shipment, quick request, quote request, etc.
 * @param {*} pathname - the url path
 */
const useUserNavigationHistory = (reference, type, pathname, title) => {
  const getLastVisits = Cookies.get("lastVisits") && JSON.parse(Cookies.get("lastVisits"));
  const [lastVisits, setLastVisits] = useState(getLastVisits?.length > 0 ? getLastVisits : []);

  // Save last visits to cookies
  useEffect(() => {
    Cookies.set("lastVisits", JSON.stringify(lastVisits));
  }, [reference, lastVisits]);

  // Save last visit to state
  useEffect(() => {
    const object = {
      display_type: type,
      reference_number: reference,
      path: pathname,
      date: new Date(),
      title,
    };
    if (reference) {
      // Remove the last visit if it already exists
      const visited = lastVisits.filter((item) => item.reference_number !== object.reference_number);

      // Add the new visit to the beginning of the array
      setLastVisits([...visited, object]);
    }
  }, [reference]);
};

export default useUserNavigationHistory;
